import { AccountNotFoundError, } from "@alchemy/aa-core";
import {} from "viem";
import { isMultisigModularAccount } from "../../../account/multisigAccount.js";
import { MultisigPlugin } from "../plugin.js";
import { MultisigAccountExpectedError } from "../../../errors.js";
export async function getThreshold(client, args) {
    const account = args.account ?? client.account;
    if (!account) {
        throw new AccountNotFoundError();
    }
    if (!isMultisigModularAccount(account)) {
        throw new MultisigAccountExpectedError();
    }
    const [, threshold] = await MultisigPlugin.getContract(client, args.pluginAddress).read.ownershipInfoOf([account.address]);
    return threshold === 0n ? account.getLocalThreshold() : threshold;
}
//# sourceMappingURL=getThreshold.js.map